import _ from 'lodash';
export function generateApplicationPayloadFromGetRequest(getResponse) {
    if (!_.get(getResponse, 'requested_products.length')) return;

    const requestedProductsPayload = getResponse.requested_products.map(
        ({
            product_type,
            amount,
            duration,
            purpose,
            urgency,
            detailed_purpose
        }) => ({
            product_type,
            amount,
            duration: ifNullUseDefault(duration, undefined),
            purpose: ifNullUseDefault(purpose, 'other'),
            urgency: ifNullUseDefault(urgency, undefined),
            detailed_purpose: ifNullUseDefault(detailed_purpose, undefined)
        })
    );

    const applicationPayload = {
        data: {
            requested_products: requestedProductsPayload
        }
    };
    return JSON.stringify(applicationPayload);
}

export function getUpdatedRequestedProducts(
    applicationData = {},
    updatedProductConfiguration
) {
    const PUT_APPLICATION_WHITELIST = [
        'product_type',
        'amount',
        'duration',
        'purpose',
        'urgency',
        'detailed_purpose'
    ];

    const requested_products = applicationData.requested_products.map(
        (requestedProduct) => {
            const updatedProduct = [];
            for (const [key, value] of Object.entries(requestedProduct)) {
                const isValidApplicationSetting = _.includes(
                    PUT_APPLICATION_WHITELIST,
                    key
                );
                if (!isValidApplicationSetting) continue;

                const updatedProductConfigValue =
                    updatedProductConfiguration[key];

                const updatedValue =
                    updatedProductConfigValue !== undefined
                        ? updatedProductConfigValue
                        : ifNullUseDefault(value);

                if (!updatedValue) continue;

                updatedProduct.push([key, updatedValue]);
            }

            return Object.fromEntries(updatedProduct);
        }
    );

    return requested_products;
}

function ifNullUseDefault(valueToCheck, defaultValue) {
    return valueToCheck === null ? defaultValue : valueToCheck;
}
